import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

type Entity = models.MatrizTarifaDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre }) },
    { title: "Distancias (km)", cell: x => ({ data: x.Distancias, view: kea.arrayCell() }) },
    { title: "Pesos (kg)", cell: x => ({ data: x.Pesos, view: kea.arrayCell() }) },
    { title: "Tarifas ($)", cell: x => ({ data: x.Precios, view: kea.arrayCell() }) },
    { title: "Es general", cell: x => ({ data: x.EsGeneral }) },
];

////////////////////////////////////
export interface BotonesDeps {
    onBorrar: (item: Entity) => void;
    onEdit: (item: Entity) => void;
    OnDuplicar: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Modificar matriz de tarifas",
            style: "primary",
            iconClass: fa("pencil", "fw"),
            onClick: deps.onEdit
        }, {
            tooltip: "Eliminar matriz de tarifas",
            style: "danger",
            iconClass: fa("trash", "fw"),
            onClick: deps.onBorrar
        }, {
            tooltip: "Duplicar matriz de tarifas",
            style: "info",
            iconClass: fa("copy", "fw"),
            onClick: deps.OnDuplicar
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "300px"
            })
        })
    }
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/list/columns.tsx